import { RouteRecordRaw } from 'vue-router';
import { DirectoriesPage } from '@/pages/directories';

export const routeName = 'Diretorios';

export const route: RouteRecordRaw = {
  path: 'diretorios',
  name: routeName,
  component: DirectoriesPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Diretórios',
    hideBreadcrumb: true,
    permissions: [{ action: 'read', subject: 'Directory' }],
  },
};
